import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../../components/shared/hoc/withAdminPageTemplate'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {NatGetApplicationStatusDetail} from '../repository/NatGetApplicationStatus'
import {NatBicycleParkingUseApplyDetail} from '../repository/NatGetBicycleParkingUseApply'
import {
    SecondaryTableCell,
    SecondaryTableRowName,
    StyledTableCaption,
    TableRowName,
    TableRowNameTop,
} from '../../../../styledComponents/adminPage/Table'
import {
    APPLY_CATEGORY,
    APPLY_IRREGULAR_PATTERN,
    MESSAGE_TYPE,
    RESIDENT_APPLY_PROCESS,
    RESIDENT_APPLY_STATUS,
    ROLE_FOR_ADMINISTRATOR,
    USER_ATTRIBUTE,
} from '../../../../CodeMaster'
import {getApplicant} from '../common/helper/NatApplicationHelper'
import {BackLink, PrintLink} from '../../../../styledComponents/adminPage/Links'
import {Box, Table, TableBody, TableRow} from '@mui/material'
import moment from 'moment'
import {
    ApplyButtonTextWithIcon,
    ApplyReceptionOutlinedButton,
    ApplyRejectionOutlinedButton,
    DelegateApprovalButton,
    SpApplicationDetailInfoContent,
    SpApplicationDetailInfoContentName,
    SpApplicationDetailInfoContentValue,
    SpApplicationInfoArea,
    SpApplicationInfoFooter,
    SpApplyCategory,
    SpApplyStatusCell,
    SpBackLinkArea,
    SpDelegateApprovalButton,
    SpPageFooterArea,
    StyledTableCell,
} from '../common/admin/NatAdminApplicationCommon'
import {
    FullWidthRowFlexContainer,
    LeftColumnFlexContainer,
    RightRowFlexContainer,
} from '../../../../styledComponents/FlexComponents'
import NatAdminApplicationRejectionDialog from '../common/admin/NatAdminApplicationRejectionDialog'
import ReactToPrint from 'react-to-print'
import {Messages} from '../../../../Messages'
import {HeadingAreaMessageParams} from '../../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import NatAdminApplicationReceptionDialog from '../common/admin/NatAdminApplicationReceptionDialog'
import NatAdminApplicationApprovalDelegateDialog from '../common/admin/NatAdminApplicationApprovalDelegateDialog'
import NatAdminApplicationApprovalDirectorDelegateComponent
    from '../common/admin/NatAdminApplicationApprovalDirectorDelegateComponent'
import NatAdminApplicationApprovalDialog from '../common/admin/NatAdminApplicationApprovalDialog'
import {NatApplicationStatusComponent} from '../common/admin/NatApplicationStatusComponent'
import {HKConstants} from '../../../../HKConstants'
import AuthorityChecker from '../../../../components/AuthorityChecker'
import {NatBicycleParkingApplicationDocument} from '../common/admin/print/NatBicycleParkingApplicationDocument'
import {
    NatPutRejectionBicycleParkingUseApplyRequest,
    NatPutRejectionBicycleParkingUseApplyResponse,
} from '../repository/NatPutRejectionBicycleParkingUseApply'
import {
    NatPutApprovalBicycleParkingUseApplyResponse,
    NatPutApprovalsBicycleParkingUseApplyRequest,
} from '../repository/NatPutReceptionBicycleParkingUseApply'
import {SessionStorageHelper} from '../../../../SessionStorageHelper'
import {getRandomKey} from '../../../common/util/Natutil'
import {NatAdminSpApplicationTabComponent} from '../common/admin/NatAdminSpApplicationTabComponent'
import {formatDate, formatDateTimeWithoutSeconds} from '../../../../formatters/formatDate'
import {Check, Close} from '@mui/icons-material'
import {PrintContentArea} from '../common/admin/print/NatAdminApplicatioPrintCommonStyle'
import {AppAdminContext} from '../../../../app/AppAdminContext'
import {NatAdminApplicationCommentToAssocDirector} from '../common/admin/NatAdminApplicationCommentToAssocDirector'
import {Location} from 'react-router-dom'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    condominiumCd: string
    applyId: string
    applicationRepo: NatApplicationRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    bicycleParkingUseApplyDetail: NatBicycleParkingUseApplyDetail
    applicationStatusDetail: NatGetApplicationStatusDetail
    receptionComment: string
    rejectionComment: string
    approvalComment: string
    isLoadCompleted: boolean
    dialogStatus: Nullable<DialogContentType>
    actingChecked: boolean
    residentApplyProcess: RESIDENT_APPLY_PROCESS
}

type DialogContentType = 'reception' | 'rejection' | 'delegate' | 'delegateApproval' | 'delegateRejection' | 'approval'

class NatAdminBicycleParkingUseApplyPage extends Component<Props & AdminPagePropsSet, States> {
    declare context: React.ContextType<typeof AppAdminContext>
    ownUrl: string
    componentRef: RefObject<HTMLDivElement>
    roleId: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        this.state = {
            bicycleParkingUseApplyDetail: {
                applyId: '',
                applyStatus: '',
                condominiumName: '',
                ridgeName: '',
                roomNumber: '',
                applicantFamilyName: '',
                applicantFirstName: '',
                applyDate: '',
                useArea: '',
                useStartDate: '',
                userFamilyName: '',
                userFirstName: '',
                userAttribute: '',
                ownerFamilyName: '',
                ownerFirstName: '',
                bicycleRegistrationNumber: '',
                version: 0,
            },
            applicationStatusDetail: {
                applyStatusInfo: [],
            },
            receptionComment: '',
            rejectionComment: '',
            approvalComment: '',
            actingChecked: true,
            dialogStatus: null,
            isLoadCompleted: false,
            residentApplyProcess: RESIDENT_APPLY_PROCESS.RECEPTION,
        }
        this.ownUrl = this.props.location.pathname
        this.componentRef = React.createRef()

        this.handleDialogCancelClick = this.handleDialogCancelClick.bind(this)
        this.handleReceptionClick = this.handleReceptionClick.bind(this)
        this.handleReceptionOkClick = this.handleReceptionOkClick.bind(this)
        this.handleRejectionClick = this.handleRejectionClick.bind(this)
        this.handleRejectionOkClick = this.handleRejectionOkClick.bind(this)
        this.handleApprovalClick = this.handleApprovalClick.bind(this)
        this.handleApprovalOkClick = this.handleApprovalOkClick.bind(this)
        this.handleDelegateClick = this.handleDelegateClick.bind(this)
        this.handleDelegateApprovalClick = this.handleDelegateApprovalClick.bind(this)
        this.handleDelegateApprovalOkClick = this.handleDelegateApprovalOkClick.bind(this)
        this.handleDelegateRejectionClick = this.handleDelegateRejectionClick.bind(this)
        this.handleDelegateRejectionOkClick = this.handleDelegateRejectionOkClick.bind(this)
        this.handleRejectionCommentChange = this.handleRejectionCommentChange.bind(this)
        this.handleReceptionCommentChange = this.handleReceptionCommentChange.bind(this)
        this.handleApprovalCommentChange = this.handleApprovalCommentChange.bind(this)
        this.onChangeActingChecked = this.onChangeActingChecked.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await this.getApplyInfo()
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({
                    isLoadCompleted: true,
                },
            )
        }
        this.showInitialMessage()
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getApplyInfo(): Promise<void> {
        const [bicycleParkingUseApplyResponse, applicationStatusResponse] = await Promise.all([
            this.getBicycleParkingUseApply(),
            this.getApplicationStatus(),
        ])

        if (bicycleParkingUseApplyResponse && applicationStatusResponse) {
            const residentApplyProcess: RESIDENT_APPLY_PROCESS =
                bicycleParkingUseApplyResponse.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value
                    ? RESIDENT_APPLY_PROCESS.RECEPTION : RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL
            this.setState({
                bicycleParkingUseApplyDetail: bicycleParkingUseApplyResponse,
                applicationStatusDetail: applicationStatusResponse,
                residentApplyProcess: residentApplyProcess,
            })
        }
    }

    async getBicycleParkingUseApply(): Promise<Nullable<NatBicycleParkingUseApplyDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getBicycleParkingUseApply.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    async getApplicationStatus(): Promise<Nullable<NatGetApplicationStatusDetail>> {
        const {condominiumCd, applyId, applicationRepo, eventEmitter} = this.props

        const response = await this.props.asyncCallFunction(
            applicationRepo.getApplicationStatus.bind(applicationRepo, condominiumCd, applyId),
            (httpErrorOrNetworkError) => {
                eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )
        return response ? response.details : response
    }

    handleDialogCancelClick(): void {
        this.setState({dialogStatus: null, actingChecked: true, receptionComment: '', approvalComment: ''})
    }

    handleReceptionClick(): void {
        this.setState({dialogStatus: 'reception'})
    }

    handleRejectionClick(): void {
        this.setState({dialogStatus: 'rejection'})
    }

    handleApprovalClick(): void {
        this.setState({dialogStatus: 'approval'})
    }

    handleDelegateClick(): void {
        this.setState({dialogStatus: 'delegate'})
    }

    handleDelegateApprovalClick(): void {
        this.setState({dialogStatus: 'delegateApproval'})
    }

    handleDelegateRejectionClick(): void {
        this.setState({dialogStatus: 'delegateRejection'})
    }

    handleRejectionCommentChange(value: string): void {
        this.setState({rejectionComment: value})
    }

    handleReceptionCommentChange(value: string): void {
        this.setState({receptionComment: value})
    }

    handleApprovalCommentChange(value: string): void {
        this.setState({approvalComment: value})
    }

    async handleRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, bicycleParkingUseApplyDetail, residentApplyProcess} = this.state

        const assocFlag = this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionBicycleParkingUseApplyRequest = {
                operation: residentApplyProcess.value,
                comment: rejectionComment,
                version: bicycleParkingUseApplyDetail.version,
            }

            const response: Nullable<NatPutRejectionBicycleParkingUseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionBicycleParkingUseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                if (!assocFlag) {
                    this.props.navigate(`${this.ownUrl}`, {
                        replace: true,
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0004.toString('申請'),
                            },
                            refreshToken: getRandomKey(),
                        },
                    })
                } else {
                    this.props.navigate('/admin/applications', {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IPCDA0006.toString(
                                    '申請',
                                    this.state.bicycleParkingUseApplyDetail.applyId,
                                    APPLY_CATEGORY.BICYCLE_PARKING_USE_APPLY.label),
                            },
                        },
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleReceptionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {receptionComment, bicycleParkingUseApplyDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsBicycleParkingUseApplyRequest = {
                operation: residentApplyProcess.value,
                comment: receptionComment,
                version: bicycleParkingUseApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalBicycleParkingUseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalBicycleParkingUseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0003.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, bicycleParkingUseApplyDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsBicycleParkingUseApplyRequest = {
                operation: residentApplyProcess.value,
                comment: approvalComment,
                version: bicycleParkingUseApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalBicycleParkingUseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalBicycleParkingUseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate('/admin/applications', {
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0005.toString(
                                '申請',
                                this.state.bicycleParkingUseApplyDetail.applyId,
                                APPLY_CATEGORY.BICYCLE_PARKING_USE_APPLY.label),
                        },
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateApprovalOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {approvalComment, bicycleParkingUseApplyDetail, residentApplyProcess} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutApprovalsBicycleParkingUseApplyRequest = {
                operation: residentApplyProcess.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: approvalComment,
                version: bicycleParkingUseApplyDetail.version,
            }

            const response: Nullable<NatPutApprovalBicycleParkingUseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.approvalBicycleParkingUseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0007.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleDelegateRejectionOkClick(): Promise<void> {
        const {applicationRepo, condominiumCd, applyId} = this.props
        const {rejectionComment, bicycleParkingUseApplyDetail} = this.state

        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutRejectionBicycleParkingUseApplyRequest = {
                operation: RESIDENT_APPLY_PROCESS.ASSOC_DIRECTOR_APPROVAL.value,
                irregularPattern: APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL.value,
                comment: rejectionComment,
                version: bicycleParkingUseApplyDetail.version,
            }

            const response: Nullable<NatPutRejectionBicycleParkingUseApplyResponse> =
                await this.props.asyncCallFunction(
                    applicationRepo.rejectionBicycleParkingUseApply
                        .bind(applicationRepo, condominiumCd, applyId, request),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.ESYCC0004.toString('申請')},
                )

            if (response && response.requestError === null) {
                this.props.navigate(`${this.ownUrl}`, {
                    replace: true,
                    state: {
                        initialMessage: {
                            title: null,
                            messageLevel: MESSAGE_TYPE.INFORMATION,
                            detail: Messages.IPCDA0004.toString('申請'),
                        },
                        refreshToken: getRandomKey(),
                    },
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeActingChecked(checked: boolean): void {
        this.setState({actingChecked: !checked})
    }

    renderDetailsTable(): ReactNode {
        const {
            applyId,
            applyDate,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            useArea,
            useStartDate,
            userFamilyName,
            userFirstName,
            userAttribute,
            ownerFamilyName,
            ownerFirstName,
            bicycleRegistrationNumber,
        } = this.state.bicycleParkingUseApplyDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        const userAttributeLabel = (userAttribute) ?
            USER_ATTRIBUTE.codeToEnumConstants(userAttribute).label : ''

        return (
            <>
                <Table>
                    <StyledTableCaption>申請内容</StyledTableCaption>
                    <TableBody>
                        <TableRow>
                            <TableRowName>申請ID</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {applyId}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請区分</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {APPLY_CATEGORY.BICYCLE_PARKING_USE_APPLY.label}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請者</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {condominiumName + '　' + applicant}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>申請日</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {moment(applyDate).format('YYYY年M月D日 H時m分')}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>使用区画</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {useArea}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>使用開始日</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {moment(useStartDate).format('YYYY年M月D日')}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>使用者</TableRowName>
                            <StyledTableCell colSpan={4}>
                                {userFamilyName + '　' + userFirstName + '（' + userAttributeLabel + '）'}
                            </StyledTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowNameTop rowSpan={4}>自転車情報</TableRowNameTop>
                            <SecondaryTableRowName>
                                所有者
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {ownerFamilyName} {ownerFirstName}
                            </SecondaryTableCell>
                        </TableRow>
                        <TableRow>
                            <SecondaryTableRowName end>
                                自転車登録番号
                            </SecondaryTableRowName>
                            <SecondaryTableCell colSpan={3}>
                                {bicycleRegistrationNumber}
                            </SecondaryTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderPageHeaderArea(): ReactNode {
        const {bicycleParkingUseApplyDetail} = this.state

        return (
            <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                <Box mt={'20px'}>
                    <RightRowFlexContainer>
                        <ReactToPrint
                            trigger={() => (
                                <PrintLink>
                                    <Box ml={'10px'}>
                                        印刷する
                                    </Box>
                                </PrintLink>
                            )}
                            content={() => this.componentRef.current}/>
                        <PrintContentArea>
                            <div ref={this.componentRef}>
                                <NatBicycleParkingApplicationDocument
                                    bicycleParkingApplicationFormParam={bicycleParkingUseApplyDetail}
                                    applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                                />
                            </div>
                        </PrintContentArea>
                    </RightRowFlexContainer>
                </Box>
            </AuthorityChecker>
        )
    }

    renderPageFooterArea(): ReactNode {
        const {bicycleParkingUseApplyDetail} = this.state

        return (
            <>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧に戻る
                    </BackLink>
                </PageFotterAreaLeft>
                {(bicycleParkingUseApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <DelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </DelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><Box ml={'8px'}/>承認する
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
                {(bicycleParkingUseApplyDetail.applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <PageFotterAreaRight>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><Box ml={'8px'}/>却下する
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><Box ml={'8px'}/>受け付ける
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </PageFotterAreaRight>
                }
            </>
        )
    }

    renderPc(): ReactNode {
        return (
            <>
                <Box mb={'20px'}>
                    {this.renderPageHeaderArea()}
                </Box>
                <PageMainArea>
                    {this.renderDetailsTable()}
                    <NatApplicationStatusComponent
                        currentApplyStatus={this.state.bicycleParkingUseApplyDetail.applyStatus}
                        applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                    />
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }

    renderSpApplicantInfo(): ReactNode {
        const {bicycleParkingUseApplyDetail} = this.state
        const {
            applyId,
            condominiumName,
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
            applyDate,
            applyStatus,
        } = bicycleParkingUseApplyDetail

        const applicant = getApplicant(
            ridgeName,
            roomNumber,
            applicantFamilyName,
            applicantFirstName,
        )

        return (
            <SpApplicationInfoArea>
                <LeftColumnFlexContainer>
                    <div>{applyId}</div>
                    <FullWidthRowFlexContainer>
                        <SpApplyCategory>
                            {APPLY_CATEGORY.BICYCLE_PARKING_USE_APPLY.label}
                        </SpApplyCategory>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPLICATION_PRINT_APPLICATION}>
                            <ReactToPrint
                                trigger={() => (
                                    <PrintLink>
                                        <Box ml={'10px'}>
                                            印刷する
                                        </Box>
                                    </PrintLink>
                                )}
                                content={() => this.componentRef.current}/>
                            <PrintContentArea>
                                <div ref={this.componentRef}>
                                    <NatBicycleParkingApplicationDocument
                                        bicycleParkingApplicationFormParam={bicycleParkingUseApplyDetail}
                                        applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
                                    />
                                </div>
                            </PrintContentArea>
                        </AuthorityChecker>
                    </FullWidthRowFlexContainer>
                    <Box pt={'12px'} pb={'12px'}>
                        <div>{condominiumName}</div>
                        <div>{applicant}</div>
                    </Box>
                    <SpApplicationInfoFooter>
                        <div>
                            {formatDateTimeWithoutSeconds(applyDate)} に提出
                        </div>
                        <SpApplyStatusCell status={applyStatus}>
                            {RESIDENT_APPLY_STATUS.codeToEnumConstants(applyStatus).label}
                        </SpApplyStatusCell>
                    </SpApplicationInfoFooter>
                </LeftColumnFlexContainer>
            </SpApplicationInfoArea>
        )
    }

    renderSpCommentToAssocDirector(): ReactNode {
        const {bicycleParkingUseApplyDetail, applicationStatusDetail} = this.state
        if (bicycleParkingUseApplyDetail.applyStatus !== RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) {
            return null
        }

        const commentToAssocDirectorInfo = applicationStatusDetail.applyStatusInfo
            .find(status => status.applyProcess === RESIDENT_APPLY_PROCESS.RECEPTION.value)
            ?.actual

        if (!(commentToAssocDirectorInfo?.comment)) {
            return null
        }

        return <Box pb={'16px'}>
            <NatAdminApplicationCommentToAssocDirector
                comment={commentToAssocDirectorInfo.comment}
                roleId={commentToAssocDirectorInfo.roleId}
                familyName={commentToAssocDirectorInfo.familyName}
                firstName={commentToAssocDirectorInfo.firstName}
                registerDatetime={commentToAssocDirectorInfo.registerDatetime}
            />
        </Box>
    }

    renderSpApplicationDetailInfo(): ReactNode {
        const {
            useArea,
            useStartDate,
            userFamilyName,
            userFirstName,
            userAttribute,
            ownerFamilyName,
            ownerFirstName,
            bicycleRegistrationNumber,
            applyStatus,
        } = this.state.bicycleParkingUseApplyDetail

        return (
            <>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>使用区画</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {useArea}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>使用開始日</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {formatDate(useStartDate)}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>使用者</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        {userFamilyName} {userFirstName}（{USER_ATTRIBUTE.codeToEnumConstants(userAttribute).label}）
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                <SpApplicationDetailInfoContent>
                    <SpApplicationDetailInfoContentName>自転車情報</SpApplicationDetailInfoContentName>
                    <SpApplicationDetailInfoContentValue>
                        所有者：{ownerFamilyName} {ownerFirstName}
                    </SpApplicationDetailInfoContentValue>
                    <SpApplicationDetailInfoContentValue>
                        自転車登録番号：{bicycleRegistrationNumber}
                    </SpApplicationDetailInfoContentValue>
                </SpApplicationDetailInfoContent>
                {(applyStatus === RESIDENT_APPLY_STATUS.ASSOC_DIRECTOR_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_DELEGATE_APPLICATION}>
                            <SpDelegateApprovalButton onClick={this.handleDelegateClick}>
                                この申請の承認操作を代行する
                            </SpDelegateApprovalButton>
                        </AuthorityChecker>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.APPROVAL_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleApprovalClick}>
                                <Check/><ApplyButtonTextWithIcon>承認する</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
                {(applyStatus === RESIDENT_APPLY_STATUS.RECEPTION_WAITING.value) &&
                    <SpPageFooterArea>
                        <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.RECEPTION_APPLICATION}>
                            <ApplyRejectionOutlinedButton onClick={this.handleRejectionClick}>
                                <Close/><ApplyButtonTextWithIcon>却下する</ApplyButtonTextWithIcon>
                            </ApplyRejectionOutlinedButton>
                            <Box ml={'24px'}/>
                            <ApplyReceptionOutlinedButton onClick={this.handleReceptionClick}>
                                <Check/><ApplyButtonTextWithIcon>受け付ける</ApplyButtonTextWithIcon>
                            </ApplyReceptionOutlinedButton>
                        </AuthorityChecker>
                    </SpPageFooterArea>
                }
            </>
        )
    }

    renderSpApplicationStatusInfo(): ReactNode {
        return (
            <NatApplicationStatusComponent
                currentApplyStatus={this.state.bicycleParkingUseApplyDetail.applyStatus}
                applyStatusInfoList={this.state.applicationStatusDetail.applyStatusInfo}
            />
        )
    }

    renderSp(): ReactNode {
        return (
            <>
                <SpBackLinkArea>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/applications`,
                        )}
                    >
                        申請状況一覧
                    </BackLink>
                </SpBackLinkArea>
                {
                    this.renderSpApplicantInfo()
                }
                <Box height={'16px'}/>
                {this.renderSpCommentToAssocDirector()}
                <NatAdminSpApplicationTabComponent
                    detailInfo={this.renderSpApplicationDetailInfo()}
                    statusInfo={this.renderSpApplicationStatusInfo()}
                />
                <Box height={`32px`}/>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const spMode = this.context.showSpModePage

        return (
            <>
                {spMode ? this.renderSp() : this.renderPc()}
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'rejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationReceptionDialog
                    open={this.state.dialogStatus === 'reception'}
                    onCancel={this.handleDialogCancelClick}
                    onReception={this.handleReceptionOkClick}
                    onChange={this.handleReceptionCommentChange}
                    commentFormRequired={true}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'approval'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    onApproval={this.handleApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationApprovalDelegateDialog
                    open={this.state.dialogStatus === 'delegate'}
                    delegateComponent={<NatAdminApplicationApprovalDirectorDelegateComponent
                        onChange={this.onChangeActingChecked}/>}
                    rejectionButtonDisabled={this.state.actingChecked}
                    approvalButtonDisabled={this.state.actingChecked}
                    onApproval={this.handleDelegateApprovalClick}
                    onRejection={this.handleDelegateRejectionClick}
                    onCancel={this.handleDialogCancelClick}
                />
                <NatAdminApplicationApprovalDialog
                    open={this.state.dialogStatus === 'delegateApproval'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onApproval={this.handleDelegateApprovalOkClick}
                    onCancel={this.handleDialogCancelClick}
                    onChange={this.handleApprovalCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
                <NatAdminApplicationRejectionDialog
                    open={this.state.dialogStatus === 'delegateRejection'}
                    residentApplyProcess={this.state.residentApplyProcess}
                    applyIrregularPattern={APPLY_IRREGULAR_PATTERN.ASSOC_DIRECTOR_DELEGATE_APPROVAL}
                    onCancel={this.handleDialogCancelClick}
                    onRejection={this.handleDelegateRejectionOkClick}
                    onChange={this.handleRejectionCommentChange}
                    eventEmitter={this.props.eventEmitter}
                />
            </>
        )
    }
}

NatAdminBicycleParkingUseApplyPage.contextType = AppAdminContext
export default createAdminPage(NatAdminBicycleParkingUseApplyPage)
